// extracted by mini-css-extract-plugin
export default {"additionalContainer":"UploadFileV2_additionalContainer__xFJIs","fileError":"UploadFileV2_fileError__qylp6","shake":"UploadFileV2_shake__w4DSI"};